import React from 'react';

// - Add '.fill' to all body classes.
// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>

export default function Bodies() {
	return (
		<g>
			<g className="tail">
				<path className="fill" d="M359.0834961,304.7711792c-0.6818848,4.6611328-2.1442871,8.7407227-3.7849121,12.6875
					c-1.6953125,3.90625-3.6633301,7.6091309-5.8913574,11.1184082c-2.2246094,3.5117188-4.6977539,6.8381348-7.5297852,9.8974609
					c-2.8408203,3.0524902-5.9128418,5.9328613-9.8122559,8.1967773c-7.3911133,4.2910156-16.8613281,1.777832-21.1523438-5.6132812
					c-2.0727539-3.5705566-2.5490723-7.6625977-1.6633301-11.3852539c1.0534668-4.3842773,2.9345703-8.1518555,5.046875-11.7473145
					c2.1210938-3.5888672,4.6008301-6.9104004,7.3293457-10.046875c2.7250977-3.138916,5.7102051-6.0839844,8.9680176-8.8259277
					c3.3122559-2.7011719,6.8032227-5.2697754,11.0742188-7.2565918c6.1794434-2.8747559,13.5192871-0.1958008,16.394043,5.9836426
					C359.1179199,300.0494995,359.4243164,302.46698,359.0834961,304.7711792z" />
			</g>
			<path className="fill" d="M321.6542358,301.6124268c-13.0026245-16.9149475-54.2415771-28.4346924-63.8843994-32.4041748
				c0,0-21.9933929-18.7685547-36.7140961-18.7685547c-26.2734375,0-47.5722656,21.2988281-47.5722656,47.5722656
				s32.5313721,29.1589355,57.5722656,38.5722656c6.2717285,2.3574219,76.8852997,34.2780457,88.3958893,28.7803955
				S345.5444641,332.6908264,321.6542358,301.6124268z" />
			<g>
				<path className="fill" d="M195.0930176,286.253418c-10.3530273-1.7138672-20.1337891,5.2910156-21.8466797,15.6435547
					l-7.3237305,44.2670898c-1.7128906,10.3525391,5.2910156,20.1333008,15.644043,21.8461914
					c1.0498047,0.1738281,2.0932617,0.2578125,3.1240234,0.2578125c9.1289062,0,17.1831055-6.5991211,18.722168-15.9013672
					l7.3237305-44.2670898C212.4494629,297.7470703,205.4455566,287.9663086,195.0930176,286.253418z" />
				<path className="fill" d="M243.4758301,286.253418c-10.3486328-1.7138672-20.1337891,5.2910156-21.8466797,15.6435547
					l-7.3237305,44.2670898c-1.7128906,10.3525391,5.2910156,20.1333008,15.644043,21.8461914
					c1.0498047,0.1738281,2.0932617,0.2578125,3.1240234,0.2578125c9.1289062,0,17.1831055-6.5991211,18.722168-15.9013672
					l7.3237305-44.2670898C260.8322754,297.7470703,253.8283691,287.9663086,243.4758301,286.253418z" />
			</g>
			<path className="fill" d="M230.3373413,368.2766418h-11.3812714c-4.7125854,0-9.133255-2.7010803-10.9207001-7.0615234
				c-0.9146729-2.2313538-1.2354736-4.9921265-0.1945648-8.2832947c3.2383881-10.2391968,16.5957642-15.9115601,26.6977539-16.5403748
				" />
			<path className="fill" d="M181.9546204,368.2766418H170.573349c-4.7125854,0-9.133255-2.7010803-10.9207001-7.0615234
				c-0.9146729-2.2313538-1.2354736-4.9921265-0.1945648-8.2832947c3.2383881-10.2391968,16.5957642-15.9115601,26.6977539-16.5403748
				" />
			<path className="fill" d="M284.1054382,368.2766418h-11.3812866c-4.7125854,0-9.1332397-2.7010803-10.9206848-7.0615234
				c-0.9146729-2.2313538-1.2354736-4.9921265-0.1945801-8.2832947c3.2384033-10.2391968,16.5958252-15.9115601,26.6977539-16.5404663
				c-0.8057861-23.3146973,34.8178101-23.4765625,41.2861023-6.5322876
				c5.2611084,13.7819519,1.7027588,27.5638733-6.2441101,34.6651917c-2.7450562,2.4529724-6.3317261,3.7523804-10.0130615,3.7523804
				h-23.9750977H284.1054382z" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/LilDoggo/Bodies.js